<div class="component-container flex flex-col justify-center items-center">
  <div class="heading mb-[3rem]">
    {{mode === 'create' ? 'Add Food Item' : 'Edit Food Item'}}
  </div>

  <div class="details w-full flex flex-col justify-start items-center gap-[2rem]">
    <!-- FG ID -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        FG ID<span class="required-mark ml-[0.3rem]">*</span> :
      </div>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['fgId']"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="fgId"
        placeholder="Enter unique FG ID"
        type="small"
      ></app-text-input>
    </div>

    <!-- Food Name -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        Food Name<span class="required-mark ml-[0.3rem]">*</span> :
      </div>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['name']"
        [maxLength]="255"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="name"
        placeholder="Enter food name"
        type="small"
      ></app-text-input>
    </div>

    <!-- Search Terms -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">Search Terms :</div>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['searchTerms']"
        [maxLength]="500"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="searchTerms"
        placeholder="e.g. juice, fruit, organic"
        type="small"
      ></app-text-input>
    </div>

    <!-- Color -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        Color<span class="required-mark ml-[0.3rem]">*</span> :
      </div>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['color']"
        [options]="colorOptions"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="color"
        placeholder="Select color"
        type="small"
      ></app-dropdown>
    </div>

    <!-- Category -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">Category :</div>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableClearSelection]="true"
        [options]="categoryOptions"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="category"
        placeholder="Select category"
        type="small"
      ></app-dropdown>
    </div>

    <!-- Serving Amount -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        Serving Amount<span class="required-mark ml-[0.3rem]">*</span> :
      </div>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['servingAmount']"
        [maxLength]="50"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="servingAmount"
        placeholder="e.g. 1, 1/2"
        type="small"
      ></app-text-input>
    </div>

    <!-- Serving Unit -->
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        Serving Unit<span class="required-mark ml-[0.3rem]">*</span> :
      </div>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['servingUnit']"
        [maxLength]="50"
        [parentFormGroup]="form"
        class="value w-full sm:w-2/3"
        controlName="servingUnit"
        placeholder="e.g. cup, slice, oz"
        type="small"
      ></app-text-input>
    </div>
  </div>

  <div class="action-section flex flex-row justify-end items-center w-full">
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="!form.dirty"
      [isLoading]="saving"
      class="save-btn w-[15rem]"
      type="small"
    >
      {{mode === 'create' ? 'Create' : 'Save'}}
    </app-primary-button>
  </div>
</div>
